export const truckStatusOptions = [
    'Active', 
    'Inactive', 
    'Maintenance', 
    'Sold'
];

export const truckTypeOptions = [
    'Van',
    'Flatbed',
    'Trailer'
];

export const dotDocumentTypeOptions = [
    'Annual Inspection',
    'Registration (IRP)',
    'IFTA Permit',
    'ELD Mandate Compliance',
    'Drug & Alcohol Consortium',
    'UCR Registration',
    'Other'
];

// Helper function to format dates (can move here from List components)
export const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        // Use options for consistency and locale awareness
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' }; 
        return new Date(dateString).toLocaleDateString(undefined, options);
    } catch (e) {
        return 'Invalid Date';
    }
};

// Helper to check expiry status (can move here from List components)
export const getExpiryStatus = (expiryDate) => {
    if (!expiryDate) return { label: 'N/A', color: 'default' };
    const today = new Date();
    // Set time to 0 to compare dates only
    today.setHours(0, 0, 0, 0);
    const expiry = new Date(expiryDate);
    expiry.setHours(0, 0, 0, 0);

    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) {
        return { label: 'Expired', color: 'error' };
    }
    if (diffDays === 0) {
        return { label: 'Expires Today', color: 'warning' };
    }
    if (diffDays <= 30) {
        return { label: `Expires in ${diffDays} days`, color: 'warning' };
    }
    return { label: formatDate(expiryDate), color: 'success' };
}

/** Company display timezone for time-off (always Central). */
export const COMPANY_TIMEZONE = 'America/Chicago';

export function formatDateTimeCentral(date) {
    if (!date) return '—';
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('en-US', {
        timeZone: COMPANY_TIMEZONE,
        timeZoneName: 'short',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
    });
}

// Session timeout constants for PII security
export const SESSION_TIMEOUTS = {
    IDLE_TIMEOUT: 60 * 60 * 1000, // 60 minutes
    ABSOLUTE_TIMEOUT: 24 * 60 * 60 * 1000, // 24 hours
    REMEMBER_ME_TIMEOUT: 14 * 24 * 60 * 60 * 1000, // 14 days
    WARNING_BEFORE_LOGOUT: 3 * 60 * 1000, // 3 minutes
    ACTIVITY_EVENTS: ['mousedown', 'keydown', 'scroll', 'touchstart']
}; 